import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { ChevronRight } from "lucide-react";

import DataFetcher from "../../hooks/DataFetcherPosgrados";
import Breadcumbs from "../../components/Breadcumbs";
import ConectUs from "../../components/ConectUs";
import BannerGeneral from "../../components/BannerGeneral";
import InfoCards from "../../components/posgrados/InfoCards";
import Modalidad from "../../components/posgrados/Modalidad";
import Duracion from "../../components/posgrados/Duracion";
import MallaGrado from "../../components/posgrados/MallaGrado";
import HeroBannerGrado from "../../components/posgrados/HeroBannerGrado";
import DescuentosTecnologias from "../homenew/DescuentosTecnologias";

// 1. URL CORRECTA: Pide "field_url_postulacion_en_linea" para que el Fetcher lo reciba y lo procese
const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/tecnologias/28b63a4f-185d-4c86-8575-8063f1bd3a69" +
  "?include=field_imagen_portada.field_media_image," +
  "field_imagen_perfil_profesional.field_media_image,field_imagen_director.field_media_image" +
  "&fields[node--tecnologias]=title,field_publicado,field_imagen_portada,field_texto_portada,field_modalidad,field_duracion,field_titulo,field_inicio_clases,field_enlace_postulacion," +
  "field_perfil_profesional,field_imagen_perfil_profesional,field_descripcion_malla,field_malla_curricular,field_imagen_director,field_texto_director,field_bloque1" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

// Función auxiliar para extraer el ID del video de YouTube (soporta varios formatos de URL)
const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11
    ? `https://www.youtube.com/embed/${match[2]}`
    : null;
};

const DataDisplay = ({ data }) => {
  const fadeUp = {
    initial: { y: 40 },
    whileInView: { y: 0 },
    transition: { duration: 0.6 },
  };
  const processContent = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");

      if (src && !src.startsWith("http")) {
        img.setAttribute(
          "src",
          `https://be-ofertas.utpl.edu.ec/${src.replace(/^\/+/, "")}`,
        );
      }
    });

    return doc.body.innerHTML;
  };
  return (
    <div className="bg-white overflow-hidden mt-16">
      {/* HERO */}
      <HeroBannerGrado
        image={data?.imagen_portada}
        content={data?.field_texto_portada}
        showApply={data?.field_publicado}
        applyUrl={data?.field_enlace_postulacion?.uri}
        brochure={data.brochure}
      />
      {/* BREADCRUMBS */}
      <div className="border-b border-slate-200 bg-white">
        <div className="mb-6">
          <Breadcumbs
            content={
              <div className="flex items-center gap-2 text-sm">
                <NavLink
                  to="/tecnologias"
                  className="hover:text-gray-900 transition-colors"
                >
                  Tecnologías
                </NavLink>
                <ChevronRight size={16} className="text-gray-400" />
                <p className="text-[#febe10] font-bold"> {data.titulo}</p>
              </div>
            }
          />
        </div>
      </div>

      {/* INFO CARDS  */}
      <InfoCards
        showApply={data?.field_publicado}
        titulo={data.titulo_recibir}
        inversion={
          <>
            {data.precio_enlinea && data.precio_presencial ? (
              <ul>
                <li>En línea: {data.precio_enlinea}</li>
                <li>Presencial: {data.precio_presencial}</li>
              </ul>
            ) : (
              <>
                {data.precio_enlinea && <p> {data.precio_enlinea}</p>}
                {data.precio_presencial && <p> {data.precio_presencial}</p>}
              </>
            )}

            <span className="block text-[9px] font-normal text-slate-400 leading-snug">
              Los costos son referenciales y pueden variar según el número de
              créditos, becas y descuentos a los que acceda cada estudiante.
            </span>
          </>
        }
        inicio={data.inicio}
        duracion={
          <>
            <Duracion value={data.duracion}></Duracion>
          </>
        }
        modalidad={<Modalidad value={data.modalidad}></Modalidad>}
      ></InfoCards>

      {data.descripcion_carrera && (
        <div className="max-w-6xl mx-auto py-24 px-6 lg:px-0 [&_h2]:font-bold">
          <div
            dangerouslySetInnerHTML={{
              __html: processContent(data.descripcion_carrera),
            }}
          />
        </div>
      )}

      {/* PERFIL profesional */}
      <section id="profesional" className="py-24  bg-slate-50 ">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-20 items-center py-4">
          <motion.div {...fadeUp}>
            <div className="px-8 lg:px-0">
              <div
                className=" 
                [&_h2]:font-bold"
                dangerouslySetInnerHTML={{
                  __html: data.perfil_profesional,
                }}
              />
            </div>
          </motion.div>

          <motion.div {...fadeUp}>
            <img
              src={data.imagen_perfilprofesional}
              alt="Perfil"
              className="w-full h-[550px] object-cover rounded-3xl shadow-2xl"
            />
          </motion.div>
        </div>
      </section>

      <MallaGrado
        title={data.descripcion_malla}
        content={data.malla}
      ></MallaGrado>

      {/* DIRECTOR */}
      {data.director && (
        <section className="py-24 bg-white">
          <div className="max-w-6xl mx-auto  grid lg:grid-cols-2 gap-20 items-center">
            <motion.div {...fadeUp}>
              <img
                src={data.imagen_director}
                alt="Director"
                className="w-auto h-[550px] object-cover rounded-3xl shadow-2xl"
              />
            </motion.div>

            <motion.div className="px-10 lg:px-0" {...fadeUp}>
              <div
                className="  mt-6 link-with-arrow-1 [&_h4]:text-gray-600 [&_h4]:text-base [&_h4]:uppercase "
                dangerouslySetInnerHTML={{
                  __html: data.director,
                }}
              />
            </motion.div>
          </div>
        </section>
      )}

      <DescuentosTecnologias></DescuentosTecnologias>

      {data.bloque1 && (
        <div
          className="max-w-4xl mx-auto my-10"
          dangerouslySetInnerHTML={{
            __html: processContent(data.bloque1),
          }}
        />
      )}
    </div>
  );
};

export default function TecnologiaContabilidad() {
  return (
    <>
      <DataFetcher url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcher>
   <div className="padding2">
        <ConectUs
          facebook="https://www.facebook.com/utpltec/"
          instagram="https://www.instagram.com/utpltec/"
          tiktok="https://www.tiktok.com/@utpltec"
          x="https://twitter.com/utpl?lang=es"
          youtube="https://www.youtube.com/user/utpl/"
          linkedin="https://www.linkedin.com/company/utpl-tec/"
        />
      </div>
      <BannerGeneral />
    </>
  );
}
